require("../components/inputFormatter");

const showModal = (html) => {
    const $modal = $(html);

    $("body").append($modal);

    setTimeout(() => {
        $modal.modal({});
        $modal.on("hidden.bs.modal", function (event) {
            setTimeout(() => {
                $modal.remove();
            }, 1000);
        });
    }, 10);
};

const showLoading = (selector) => {
    const $button = $(selector);
    const text = $button.text();
    const isSecondaryBtn = $button.hasClass("secondary");
    const btn = `<button ${
        isSecondaryBtn ? "class='secondary'" : 'class="primary" type="submit"'
    }  disabled="disabled"><div id="pdp-loading" class="${isSecondaryBtn ? "secondary" : ""}"/></button>`;
    $button.replaceWith(btn);
    return text;
};

const hideLoading = (selector, text) => {
    const $button = $(selector);
    const isSecondaryBtn = $button.hasClass("secondary");
    const btn = `<button ${isSecondaryBtn ? "class='secondary'" : 'class="primary" type="submit"'} >${text}</button>`;
    $button.replaceWith(btn);
};

const fillPrizeConfirmationModal = () => {

    const $contactMessage = $('.ITA-prize-contact-message');
    const contactText = $contactMessage.html();
    const phone = $('.receiver-phone-number').text();
    const email = $('.receiver-email').text();
    const parsedContactText = $.parseHTML(contactText.replace('PHONE', phone).replace('EMAIL', email));

    $('.contact-message').empty().append(parsedContactText);

    const $confirmMessage = $('.ITA-prize-confirmation-message');
    const confirmText = $confirmMessage.html();
    const quantity = parseInt($('.quantity').text());
    const points = $('.event-points').text();
    const replaceText = confirmText.replace('QUANTITY', quantity).replace('POINTS', points);

    function replacePluralExpressions(text, isPlural) {
        return text.replace(/(\w+)\$PLURAL\$(\w+)/g, (match, singular, plural) => {
          return isPlural ? plural : singular;
        });
      }

    const parsedConfirmText = $.parseHTML(replacePluralExpressions(replaceText, quantity > 1));
    $('.confirmation-message').empty().append(parsedConfirmText);

     const consentCA = $('.ITA-consent-message').clone().removeClass('d-none');
     $('.consent-confirmation .summary-message').append(consentCA);

}

const checkPoints = () => {
    $(".offer-code-request").on("submit", function (e) {
        e.preventDefault();
        const isSecondaryBtn = $(e.originalEvent.submitter).hasClass("secondary");
        const buttonSelector = isSecondaryBtn ? ".actions-area  button.secondary" : ".actions-area  button.primary";
        const buttonText = showLoading(buttonSelector);
        const $form = $(this);
        const url = $form.attr("action");
        const method = $form.attr("method");
        $("body").trigger("accor:checkPoints", { event: e });

        $.ajax({
            type: method,
            url: url,
            data: $form.serialize(),
            success: function (data) {
                // Hide Loading
                hideLoading(buttonSelector, buttonText);
                // Open summary modal
                showModal(data.html);

                if($('.prize-redemption').length) {
                    fillPrizeConfirmationModal();
                }

                let newPoints = $(".error-modal").data("newpoints");
                if (newPoints) {
                    newPoints = parseInt(newPoints)
                    $(".customer-info p span").replaceWith("<span>" + newPoints + "</span>");
                    $(".loyalty-points").text(newPoints);
                    $(".loyalty-points").attr('data-points',newPoints);
                    $(".loyalty-points").data('points',newPoints);

                }
            },
            error: function () {
                // Hide Loading
                hideLoading(buttonSelector, buttonText);
            },
        });
    });
};

const checkConsent = () => {
    $("body").on("click", "#consent-confirmation-check", function (e) {
        if($(this).is(':checked')) {
            $('.consent-confirmation').removeClass('error');
        }
    });
}

function validatePrizeRdmFormField(fieldName, value) {
    let isValid = true;
    if(!value) {
        return false;
    }
    switch (fieldName) {
        case "firstName":
        case "lastName":
            const nameRegex = /^[\p{Letter}\s\-.']+$/u;
            if (value.length < 1 || value.length > 100 || !nameRegex.test(value)) {
                isValid = false;
            }
            break;
        case "email": 
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value.length > 160 || !emailRegex.test(value)) {
                isValid = false;
            }
            break;
        case "phoneNumber": 
            const phoneRegex = /^\+?[0-9]{8,20}$/;
            if (!phoneRegex.test(value)) {
                isValid = false;
            }
        default:
            break;
    }

    return isValid
}

const placeOrder = () => {
    $("body").on("submit", ".summary-modal form", function (e) {
        e.preventDefault();
        const buttonSelector = ".actions  button.primary";
        const $form = $(this);
        const url = $form.attr("action");
        const method = $form.attr("method");
        const $consentConfirmation = $('.consent-confirmation');
        const $summaryModal = $form.closest(".summary-modal");
        let formData = $form.serialize();

        if($summaryModal.hasClass('prize-redemption')) {
            if(!$('#consent-confirmation-check').is(':checked')) {
                $consentConfirmation.addClass('error');
                return;
            } else {
                $consentConfirmation.removeClass('error');
                ["firstName", "lastName", "email", "phoneNumber"].forEach( field => {
                    const fieldVal = encodeURIComponent($(`input[name=${field}]`).val())
                    formData += `&${field}=${fieldVal}`;
                });
            }
        }

        const buttonText = showLoading(buttonSelector);

        $.ajax({
            type: method,
            url: url,
            data: formData,
            success: (data) => {
                // Hide summary modal
                $summaryModal.modal("hide").data("bs.modal", null);
                // Hide Loading
                hideLoading(buttonSelector, buttonText);
                // Open confirmation modal
                showModal(data.html);

                handleInvalidExchangeRequest(data);

                //update header points
                let newPoints = $(".confirmation-modal").data("newpoints");
                if (newPoints || newPoints === 0) {
                    newPoints = parseInt(newPoints)
                    $(".customer-info p span").replaceWith("<span>" + newPoints + "</span>");
                    $(".loyalty-points").attr("data-points", newPoints);
                    $(".loyalty-points").data("points", newPoints);
                    $(".loyalty-points").text(newPoints);

                    const rate = $(".offer-code-request").data("rate");
                    const isDonation = $("input[name=isDonation]").val() === 'true';

                    if (rate && !isDonation) {
                        //$("#exchangeInput]").val("");   
                        $("input[name='card-number']").val("")
                        $('#exchangeInput').val($('#exchangeInput option:first').val());
                        const $accortSpan = $("span.changed-points");
                        $accortSpan.text(convertPoint($('#exchangeInput option:first').val(), rate));
                        $(".actions-area .primary").attr("disabled", "disabled");
                    }
                    }
            },
            error: function () {
                // Hide Loading
                hideLoading(buttonSelector, buttonText);
            },
        });
    });
};

handleInvalidExchangeRequest = (data) => {
    // check for invalid exchange request content asset 
    if(data.html.includes('invalid-number-request-cs')) {
        const contentAsset = $('.ITA-exchange-invalid-number').clone().removeClass('d-none');
        $('.invalid-number-request-cs').append(contentAsset);
    }
};

const calculateKey = (cardNumber) => {
    let factor = 2;
    let somme = 0;
    let base = 36;
    const regex = new RegExp("^[0-9]*$", "gm");

    if (cardNumber != null && regex.test(cardNumber)) {
        base = 10;
    }
    for (let i = cardNumber.length - 1; i >= 0; i--) {
        // conversion du caractere en valeur numerique (codePoint)
        // a=10,b=11,c=12,etc.
        let codePoint = parseInt(cardNumber[i], base);

        if (codePoint < 0 || codePoint > base - 1) {
            return "";
        }
        // calcul de l'indice associe au caractere converti en
        // base n, en multipliant alternativement par 2 ou 1
        // (commencant par 2 en partant de la gauche)
        let poids = parseInt(factor * codePoint);
        poids = parseInt(poids / base + (poids % base));
        somme += poids;
        factor = factor == 2 ? 1 : 2;
    }
    let reste = somme % base;
    let controlCodePoint = (base - reste) % base;
    // conversion du codePoint obtenu en charactere
    // puis passage en upperCase
    const result = controlCodePoint.toString(36).toUpperCase()[0];
    return result;
};

const isValidCardNumber = (number, key = "accor") => {

    let isValid = false;
    console.log(number, 'number______', key)
    switch (key) {
        case "accor":
            const n = number.substring(0, number.length - 1);
            const luhnToCheck = number.substring(number.length - 1);
            const calculatedKey = calculateKey(n);
            if (number.length !== 16) return false;

            if (luhnToCheck.toUpperCase() === calculatedKey.toUpperCase()) {
                isValid = true;
            }
            return isValid;
        case "exchange":
            const $offerCodeRequest = $('.offer-code-request');
            const rules = $offerCodeRequest.data('exchangecardrules')
            const min = rules.min;
            const max = rules.max;
            let regex = null;

            try {
                regex = rules.regex && new RegExp(rules.regex, "gm");
            } catch (error) {
                // Nothing to do ...
            }

            if (number.length >= min && number.length <= max && (!regex || number.match(regex))) {
                isValid = true;
            }

            const cardCheckMethod = $offerCodeRequest.attr('data-method-check');
            if (isValid && cardCheckMethod) {
                isValid = checkCardNumber(number, cardCheckMethod.toLowerCase());
            }

            return isValid;
        default:
            return true;
    }
};

const formInput = () => {
    const $cardInput = $("input[name=card-number]");
    const $formInputField = $(".card-input");
    const productType = $('input[name="ITA_productType"]').val();

    $formInputField.on("click", function (e) {
        $(this).addClass("active");
        $(this).find("input").focus();
    });

    $(document).mouseup(function (e) {
        if ($cardInput.val() === "" && !$formInputField.is(e.target) && $formInputField.has(e.target).length === 0) {
            $formInputField.removeClass("active");
        }
    });
    const points = $(".loyalty-points").data("points");
    $cardInput.on("input", function() {
        var self = $(this);
        self.val(self.val().replace(/[^a-zA-Z0-9]/g, ""));
      });

    $cardInput.on("blur", function () {
        const cardNumber = $cardInput.val();
        const isValid = isValidCardNumber(cardNumber,productType);
        console.log(isValid, cardNumber, 'bslur_____')
        const $convertInput = $("#exchangeInput");

        if (isValid) {
            $(".card-input").removeClass("error");
            $(".error-icon").hide();
            $(".error-message-card").hide();
            if (points !== 0 && $convertInput.val() <= points && !$(".actions-area .primary").hasClass("disabled")) {
                $(".actions-area .primary").removeAttr("disabled");
            }
        } else if (cardNumber !== "") {
            $(".card-input").addClass("error");
            $(".error-icon").show();
            $(".error-message-card").show();
            $(".actions-area .primary").attr("disabled", "disabled");
            $(".actions-area .secondary").attr("disabled", "disabled");
        } else {
            $(".actions-area .primary").attr("disabled", "disabled");
            $(".actions-area .secondary").attr("disabled", "disabled");
        }
    });
};

const isFormValid = () => ["firstName", "lastName", "email", "phoneNumber"].map( field => (validatePrizeRdmFormField(field, $(`input[name=${field}]`).val()))).every(value => value === true);

const toggleSubmitRequestCTA = (enabled) => {
    if ($(".actions-area .primary").hasClass("disabled")) return;
    if(enabled) {
        $(".actions-area .primary").removeAttr("disabled");
        $(".actions-area .secondary").removeAttr("disabled");
    } else {
        $(".actions-area .primary").attr("disabled", "disabled");
        $(".actions-area .secondary").attr("disabled", "disabled");
    }

}

const pdpPrizeFormInput = () => {
    if($('.offer-code-request.prize').length) {
        toggleSubmitRequestCTA(isFormValid());
        $(".form-input-group").each( (_, formInputField) => {
            const $formInputField = $(formInputField);
            const $formInput = $formInputField.find('input[type=text]');
            const fieldName = $formInput.attr('name');

            if($formInput.val() !== "") {
                $formInputField.addClass("active");
            }
    
            $formInputField.on("click", function (e) {
                $(this).addClass("active");
                $(this).find("input").focus();
            });
        
            $(document).mouseup(function (e) {
                if ($formInput.val() === "" && !$formInputField.is(e.target) && $formInputField.has(e.target).length === 0) {
                    $formInputField.removeClass("active");
                }
            });
        
            $formInput.on("blur", function () {
                const fieldValue = $formInput.val();
                const isValid = validatePrizeRdmFormField(fieldName, fieldValue);
                
                if (isValid) {
                    $formInputField.removeClass("error");
                    $formInputField.find(".error-icon").hide();
                    $formInputField.find(".error-message-card").hide();
        
                } else if (fieldValue !== "") {
                    $formInputField.addClass("error");
                    $formInputField.find(".error-icon").show();
                    $formInputField.find(".error-message-card").show();
                } 
                toggleSubmitRequestCTA(isFormValid());
            });
        });
    }
};

const checkCardNumber = (cardNumber, method) => {
    let isValid = false;

    switch (method) {
        case 'ean13':
            if (cardNumber.length === 13) {
                let evenSum = 0;
                let oddSum = 0;
                let currentDigit = null;
                let checkDigit = null;
                try {
                    for (let i = 0; i < cardNumber.length - 1; i++) {
                        currentDigit = parseInt(cardNumber.charAt(i));
                        if (i % 2 === 0) {
                            oddSum += currentDigit
                        } else {
                            evenSum += currentDigit;
                        }
                    }

                    checkDigit = ((evenSum * 3) + oddSum) % 10;

                    checkDigit = checkDigit > 0 ? 10 - checkDigit : checkDigit;

                    isValid = checkDigit === parseInt(cardNumber.charAt(cardNumber.length - 1))
                } catch (error) {
                    isValid = false;
                }
            }
            break;
        default:
            isValid = true;
            break;
    }

    return isValid;
}

const convertPoint = (pointsToConvert, rate) => {
    return Math.ceil(pointsToConvert * rate);
};

const convertAll =  (rate, $convertInput, $accortSpan) => {
    let points = $(".loyalty-points").data("points");
    $convertInput.val(points);
    $accortSpan.text(convertPoint(points, rate));
};
const handleChange = () => {
    let points = $(".loyalty-points").data("points");
    const rate = $(".offer-code-request").data("rate");
    const $convertInput = $("#exchangeInput");
    const $accortSpan = $("span.changed-points");

    const $cardInput = $(".card-input");
    $accortSpan.text(convertPoint($convertInput.val(),rate));
    if(points === 0 || $convertInput.val() > points) {
        $(".actions-area .primary").attr("disabled", "disabled");
    }
    $convertInput.on('change', function (e) {
        $accortSpan.text(convertPoint($convertInput.val(), rate));
        if( points === 0 || $convertInput.val() > points) {
            $(".actions-area .primary").attr("disabled", "disabled");
        }else{
            if (!$cardInput.hasClass("error") && $cardInput.val() !== "" && !$(".actions-area .primary").hasClass("disabled")){
                $(".actions-area .primary").removeAttr("disabled");
            }
        }
    });
    $(".actions-area .secondary").on("click", function (e) {
        convertAll( rate, $convertInput, $accortSpan);
    });

};

$("body").on("accor:checkPoints", function (e, source) {
    const rate = $(".offer-code-request").data("rate");
    const $convertInput = $("input[name=convert-points]");
    const $accortSpan = $("span.changed-points");
    if ("event" in source && $(source.event.originalEvent.submitter).hasClass("secondary")) {
        convertAll(rate, $convertInput, $accortSpan);
    }
});

/**
 * Updates the gift card points display when a variation is selected.
 * Listens to product:afterAttributeSelect and updates .giftcard-points-value
 * with the variant's ITA_initiativePoints.
 */
$("body").on("product:afterAttributeSelect", function (e, response) {
    const $giftcardForm = $(".offer-code-request.giftcard");
    if ($giftcardForm.length === 0) return;

    const $pointsValue = $giftcardForm.find(".giftcard-points-value");
    if ($pointsValue.length === 0) return;

    const product = response.data && response.data.product;
    if (!product || typeof product.ITA_initiativePoints === "undefined") return;

    const pointsUnit = $giftcardForm.find(".points.offer-code-section").data("points-unit") || "";
    $pointsValue.text(product.ITA_initiativePoints + " " + pointsUnit);
    $pointsValue.attr("data-initial-points", product.ITA_initiativePoints);
});

module.exports = {
    checkPoints,
    checkConsent,
    pdpPrizeFormInput,
    placeOrder,
    formInput,
    handleChange,
    methods: {},
};
